import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full mx-0 px-0md:px-10 overflow-hidden"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["id", "src"]

import {ref, computed, onMounted, onUnmounted, watch} from "vue";
import { PanchImages } from '@/assets/ts/PanchImages';

const imageFirstId = 1;
const imageLastId = 30;

export default /*@__PURE__*/_defineComponent({
  __name: 'diamond360Defaults',
  props: {
    certificate: {},
    image_url: {},
    diamondForm: {}
  },
  setup(__props: any) {

const props = __props;

const host = process.env.VUE_APP_HOST || "";
const curImageIdx = ref(imageFirstId);

const imageList = computed(() => {
  const imageList: string[] = [];

  for (let imageIdx = imageFirstId; imageIdx <= imageLastId; imageIdx++) {
    imageList.push(imageIdx.toString().padStart(3, "0"));
  }

  return imageList;
});

const setCurrentImageIdx = () => {
  if (curImageIdx.value >= imageLastId) {
    curImageIdx.value = imageFirstId;
  } else {
    curImageIdx.value++;
  }
};

const intervalId = ref();
const startAnimation = () => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = false;
  } else {
    intervalId.value = setInterval(setCurrentImageIdx, 150);
  }
};

onMounted(() => {
  checkPanchImage();
  startAnimation();
});

onUnmounted(() => {
  clearInterval(intervalId.value);
  intervalId.value = false;
});

const panchImageUrl = ref('');
const panchVideoUrl = ref('');

const checkPanchImage = async () => {
  if (!props.image_url && props.certificate) {
    const panch = new PanchImages();
    panchImageUrl.value = (await panch.getStill(props.certificate)) as string;

    if (panchImageUrl.value != "") {
      panchVideoUrl.value = panch.get360(props.certificate)
    }

  } else {
    panchImageUrl.value = '';
  }
};

watch(() => props.certificate, checkPanchImage, { deep: true });


return (_ctx: any,_cache: any) => {
  return (panchVideoUrl.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("iframe", {
          class: "w-full my-auto overflow-hidden aspect-[1/1.3]",
          src: panchVideoUrl.value
        }, null, 8, _hoisted_2)
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: startAnimation,
        class: "w-full"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (imageIdx) => {
          return (_openBlock(), _createElementBlock("img", {
            key: imageIdx,
            id: 'animation-' + imageIdx,
            alt: "",
            src: 
        _unref(host) +
        '/img/diamonds/360/rubin-diamond-' +
        __props.diamondForm.toLowerCase() +
        '-' +
        imageIdx +
        '.jpg'
      ,
            class: _normalizeClass({
        block: parseInt(imageIdx) === curImageIdx.value,
        hidden: parseInt(imageIdx) !== curImageIdx.value,
      })
          }, null, 10, _hoisted_3))
        }), 128))
      ]))
}
}

})